import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {NotificationService} from '../../utils/notification.service';
import { SignalRService } from 'app/shared/chat/signalRService.service';
import { ChatService } from 'app/shared/chat/chat.service';

declare var $:any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'sa-logout',
  template: `
<div id="logout" (click)="showPopup()" class="btn-header transparent pull-right">
        <span> <a routerlink="/auth/login" title="Salir" data-action="userLogout"
                  data-logout-msg="You can improve your security further after logging out by closing this opened browser"><i
          class="fa fa-sign-out"></i></a> </span>
    </div>
  `,
  styles: []
})
export class LogoutComponent implements OnInit {

  constructor(private router: Router,
              private notificationService: NotificationService,
              private chatService: ChatService,
              private chat: SignalRService) { }

  showPopup() {
    this.notificationService.smartMessageBox({
      title : '<i class=\'fa fa-sign-out txt-color-orangeDark\'></i> Cerrar Sesión <span class=\'txt-color-orangeDark\'><strong>' + $('#show-shortcut').text() + "</strong></span> ?",
      content : 'Esta seguro que desea salir del sistema?',
      buttons : '[No][Si]'

    }, (ButtonPressed) => {
      if (ButtonPressed == 'Si') {
        this.logout()
      }
    });
  }

  logout() {
      // this.chatService.stop();
      this.chat.stopConntection();
      localStorage.removeItem('currentUser');
      localStorage.removeItem('sucursales');
      localStorage.removeItem('sucursalRol');
      this.router.navigate(['/auth/login'])
  }

  ngOnInit() {

  }



}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/user/logout/logout.component.ts